import React from "react";

export const ORDERS = ["Deck Hand", "Salted", "OSB", "ORB", "ORSB"];

// Beret colour + tape marks per order. OSB -> purple, Salted -> yellow w/ black tape.
export const ORDER_MARKS = {
  "Deck Hand": { beret: null, tape: false },
  "Salted": { beret: "#EAB308", tape: true },
  "OSB": { beret: "#7C3AED", tape: false },
  "ORB": { beret: null, tape: false },
  "ORSB": { beret: null, tape: false },
};

// A stylised naval beret. `tape` draws a black band around the base.
export function Beret({ color = "#1E3A5F", tape = false, size = 28, className = "", testid }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} className={`shrink-0 ${className}`} role="img" aria-label="beret" data-testid={testid}>
      {/* base band / tape */}
      <rect x="11" y="37" width="42" height="8" rx="4" fill={tape ? "#0B0B0B" : color} />
      {tape && <rect x="11" y="37" width="42" height="3" rx="1.5" fill="rgba(255,255,255,0.12)" />}
      {/* beret body */}
      <path d="M7 35 C7 20 25 13 37 15 C51 17.5 59 25 56.5 33 C55 38.5 44 39.5 32 39.5 C19 39.5 8 39.5 7 35 Z" fill={color} />
      {/* stalk */}
      <circle cx="51.5" cy="15.5" r="3.2" fill={color} />
      {/* highlight */}
      <path d="M14 29 C20 23 31 21 41 23" stroke="rgba(255,255,255,0.35)" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );
}

// Pill badge showing the order name, prefixed with its beret when one is defined.
export function OrderBadge({ order, size = 22, className = "", testid }) {
  if (!order) return null;
  const mark = ORDER_MARKS[order] || {};
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border border-[hsl(var(--gold))]/30 bg-black/20 px-2.5 py-1 text-xs font-600 text-foreground ${className}`} data-testid={testid}>
      {mark.beret && <Beret color={mark.beret} tape={mark.tape} size={size} />}
      {order}
    </span>
  );
}
